module.exports = __webpack_public_path__ + "assets/media/favicon196.dc22686d92d324f2fb8207357a509722.png";